/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import { ChecklistPeriodDTO } from './ChecklistPeriodDTO';
import {ChecklistStateDTO} from './ChecklistStateDTO';
import {ControlFunctionDTO} from './ControlFunctionDTO';
import {LegalEntityCompanyDTO} from './LegalEntityCompanyDTO';
import {LegalEntityParentCompanyDTO} from './LegalEntityParentCompanyDTO';
import {LegalEntityRegionDTO} from './LegalEntityRegionDTO';
import {LegalEntitySubsidiaryDTO} from './LegalEntitySubsidiaryDTO';
import {UserDTO} from './UserDTO';

/**
 * The ChecklistMonitorDTO model module.
 * @module model/ChecklistMonitorDTO
 * @version v0
 */
export class ChecklistMonitorDTO {
  /**
   * Constructs a new <code>ChecklistMonitorDTO</code>.
   * @alias module:model/ChecklistMonitorDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistMonitorDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistMonitorDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistMonitorDTO} The populated <code>ChecklistMonitorDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistMonitorDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('fiscalYear'))
        obj.fiscalYear = ApiClient.convertToType(data['fiscalYear'], 'Number');
      if (data.hasOwnProperty('checklistPeriod'))
        obj.checklistPeriod = ChecklistPeriodDTO.constructFromObject(data['checklistPeriod']);
      if (data.hasOwnProperty('toEvaluateAt'))
        obj.toEvaluateAt = ApiClient.convertToType(data['toEvaluateAt'], 'Date');
      if (data.hasOwnProperty('evaluatedAt'))
        obj.evaluatedAt = ApiClient.convertToType(data['evaluatedAt'], 'Date');
      if (data.hasOwnProperty('supervisedEntity'))
        obj.supervisedEntity = ApiClient.convertToType(data['supervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('qualitativeOnly'))
        obj.qualitativeOnly = ApiClient.convertToType(data['qualitativeOnly'], 'Boolean');
      if (data.hasOwnProperty('visibleOnBI'))
        obj.visibleOnBI = ApiClient.convertToType(data['visibleOnBI'], 'Boolean');
      if (data.hasOwnProperty('lastModifiedBy'))
        obj.lastModifiedBy = UserDTO.constructFromObject(data['lastModifiedBy']);
      if (data.hasOwnProperty('legalEntityParentCompany'))
        obj.legalEntityParentCompany = LegalEntityParentCompanyDTO.constructFromObject(data['legalEntityParentCompany']);
      if (data.hasOwnProperty('legalEntitySubsidiary'))
        obj.legalEntitySubsidiary = LegalEntitySubsidiaryDTO.constructFromObject(data['legalEntitySubsidiary']);
      if (data.hasOwnProperty('legalEntityRegion'))
        obj.legalEntityRegion = LegalEntityRegionDTO.constructFromObject(data['legalEntityRegion']);
      if (data.hasOwnProperty('legalEntityCompany'))
        obj.legalEntityCompany = LegalEntityCompanyDTO.constructFromObject(data['legalEntityCompany']);
      if (data.hasOwnProperty('checklistState'))
        obj.checklistState = ChecklistStateDTO.constructFromObject(data['checklistState']);
      if (data.hasOwnProperty('controlFunction'))
        obj.controlFunction = ControlFunctionDTO.constructFromObject(data['controlFunction']);
        if (data.hasOwnProperty('frozen'))
        obj.frozen = ApiClient.convertToType(data['frozen'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistMonitorDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ChecklistMonitorDTO.prototype.name = undefined;

/**
 * @member {Number} fiscalYear
 */
ChecklistMonitorDTO.prototype.fiscalYear = undefined;

/**
 * @member {module:model/ChecklistPeriodDTO} checklistPeriod
 */
 ChecklistMonitorDTO.prototype.checklistPeriod = undefined;

/**
 * @member {Date} toEvaluateAt
 */
ChecklistMonitorDTO.prototype.toEvaluateAt = undefined;

/**
 * @member {Date} evaluatedAt
 */
ChecklistMonitorDTO.prototype.evaluatedAt = undefined;

/**
 * @member {Boolean} supervisedEntity
 */
ChecklistMonitorDTO.prototype.supervisedEntity = undefined;

/**
 * @member {Boolean} qualitativeOnly
 */
ChecklistMonitorDTO.prototype.qualitativeOnly = undefined;

/**
 * @member {Boolean} visibleOnBI
 */
 ChecklistMonitorDTO.prototype.visibleOnBI = undefined;

/**
 * @member {module:model/UserDTO} lastModifiedBy
 */
ChecklistMonitorDTO.prototype.lastModifiedBy = undefined;

/**
 * @member {module:model/LegalEntityParentCompanyDTO} legalEntityParentCompany
 */
ChecklistMonitorDTO.prototype.legalEntityParentCompany = undefined;

/**
 * @member {module:model/LegalEntitySubsidiaryDTO} legalEntitySubsidiary
 */
ChecklistMonitorDTO.prototype.legalEntitySubsidiary = undefined;

/**
 * @member {module:model/LegalEntityRegionDTO} legalEntityRegion
 */
ChecklistMonitorDTO.prototype.legalEntityRegion = undefined;

/**
 * @member {module:model/LegalEntityCompanyDTO} legalEntityCompany
 */
ChecklistMonitorDTO.prototype.legalEntityCompany = undefined;

/**
 * @member {module:model/ChecklistStateDTO} checklistState
 */
ChecklistMonitorDTO.prototype.checklistState = undefined;

/**
 * @member {module:model/ControlFunctionDTO} controlFunction
 */
ChecklistMonitorDTO.prototype.controlFunction = undefined;

